import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { OrderService, orderStatus } from '../../../services/order.service';
import { Order } from '../../../models/order/order.model';
import { Utils } from '../../../shared/util';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.page.html',
  styleUrls: ['./order-details.page.scss'],
})
export class OrderDetailsPage implements OnInit {

  order$: Observable<Order>
  status$: Subject<number> = new Subject()
  public orderStatus = orderStatus

  constructor(
    private orderService: OrderService,
    private route: ActivatedRoute,
    public utils: Utils,
  ) { }

  ngOnInit() {
    this.utils.setStateLoading(true)
    this.route.params.subscribe(params => {
      const orderId: string = params.id
      const restToken = params.restToken

      this.order$ = this.orderService.getById(orderId, restToken)
        .pipe(tap(order => {
          this.orderService.getStatus(order.reference).subscribe(status => {
            this.status$.next(status)
          })
          setInterval(() => {
            this.orderService.getStatus(order.reference).subscribe(status => {
              this.status$.next(status)
            })
          }, 10000)
          this.utils.setStateLoading(false)
        }))
    })
  }

  getAnimatedImageUrlByStatus(status) {
    if([orderStatus.INVISIBLE, orderStatus.PLACED, orderStatus.INTEGRATED].indexOf(status) != -1) return 'document_160.gif'
    if([orderStatus.CONFIRMED].indexOf(status) != -1) return 'hourglass_160.gif'
    if([orderStatus.DISPATCHED, orderStatus.GOING_TO_ORIGIN, orderStatus.READYTODELIVER].indexOf(status) != -1) return 'pointer.gif'
    if([orderStatus.DELIVERED, orderStatus.CONCLUDED, orderStatus.ARRIVED_AT_ORIGIN].indexOf(status) != -1) return 'check.gif'
    if([orderStatus.CANCELLED, orderStatus.CANCELLATION_REQUESTED].indexOf(status) != -1) return 'neutral.gif'
  }
}
